import { connect } from 'react-redux';
import {likesByUser, removeLikesByUser, thumbByUser} from '../actions/recipe';
import {updateFavs} from '../actions/profile';
import {ROUTES} from '../constants';
import RecipeDetailPage from '../components/pages/RecipeDetailPage';

const mapStateToProps = ({profileReducer,recipeDetailReducer}) => {
	return {
		profileReducer,
		recipeDetailReducer,
	};
};


const mapDispatchToProps = (dispatch) => {
	return {
		onClickTag : (tag)=> {
			dispatch({
				type : ROUTES.SEARCH_QUIZ_QUERIED,
				payload : {
					key : 'query',
					query : {
						word : tag
					}
				}
			});
		},
		onClickBack : ()=>{
			dispatch({
				type : ROUTES.SEARCH_QUIZ_SELECTED
			});
		},
		onClickStar : (recipe,isRemove,uid,onSucceeded)=>{
			if(isRemove){
				dispatch(removeLikesByUser(recipe,uid,onSucceeded));
				dispatch(updateFavs(recipe.id,true));
			}
			else{
				dispatch(likesByUser(recipe,uid,onSucceeded));
				dispatch(updateFavs(recipe.id));
			}
			
		},
		onClickThumbs : (recipe,uid,onSucceeded)=>{
			dispatch(thumbByUser(recipe,uid,onSucceeded));
		},
		onClickPlay : (recipe)=>{
			dispatch({
				type: ROUTES.REQUEST_PLAY_QUIZ,
				payload : {
					userId : recipe.uid,
					recipeId : recipe.id,
				}
			});
		},
		onClickUser : (uid)=>()=>{
			dispatch({
				type : ROUTES.USER,
				payload : {
					userId : uid
				}
			});
		}
	};
};


export default connect(mapStateToProps, mapDispatchToProps)(RecipeDetailPage);